import axios from "axios";
import PORTAL_BASE from "@/constants/PortalBase";

export default function searchFilters(params = []) {
  const slug = params.slug;
  delete params.slug;
  const userData = params.userData;
  delete params.userData;

  params.quotation = params.quotation ?? -1;

  if (params.orderBy) {
    params.order = params.orderBy;
  }

  const campaignMap = {
    quotation: "cotacoes",
    favorites: "favoritos"
  };

  const mappedCampaign = campaignMap[slug] || slug;
  params.campaign = mappedCampaign?.length > 0 ? mappedCampaign : null;

  if (slug === "recommendations") {
    params.order = "recforyou";
    params.relevance = "recommendations";
  }

  if (slug === "closetoend") {
    params.relevance = "close-to-end";
  }

  if (slug === "opportunities") {
    params.order = "bopotd";
    params.fipe = "70";
  }

  if (slug === "regions") {
    params.order = `rg-${userData?.user?.state ?? ''}`;
  }

  if (slug === "newcars") {
    params.newcars = "1"
  }

  if (slug === "views") {
    params.relevance = "viewed"
  }

  params.category = Object.hasOwnProperty.call(params, "category")
    ? params.category.join(",")
    : [];

  if (Array.isArray(params.vehicleCondition)) {
    params.vehicleCondition.forEach((type) => {
      if (type === "blindado") {
        params.armoured = "yes";
      } else if (type === "showroom") {
        params.showroom = "yes";
      }
    });
    delete params.vehicleCondition;
  }

  if (params.reportStatus !== "" && params.reportStatus?.length > 0) {
    params.report = "yes";
    if (
      params.reportStatus.length === 1 &&
      params.reportStatus.includes("no")
    ) {
      params.report = "no";
      params.reportStatus = "";
    }
  }

  return axios
    .postForm(`${PORTAL_BASE}/async/filtros/`, params, {
      withCredentials: true,
    })
    .then((response) => {
      return {
        ...response.data,
        vehicles: response.data.result ?? []
      }
    })
    .catch((error) => `search ${error}`);
}
